import { FieldValues, Path, RegisterOptions } from "react-hook-form";
import { HookFormInputProps, LooseRegisterOptions } from "./types";

/**
 * Builds controller rules from HookFormInputProps, combining isRequired, minLength, maxLength
 * with any additional rules passed via props.rules or extraRules.
 *
 * Note: Uses type assertion to work around react-hook-form's strict discriminated union types
 * for RegisterOptions which have complex conditional constraints on valueAsNumber/valueAsDate/pattern.
 */
export function buildControllerRules<T extends FieldValues>(
  props: HookFormInputProps<T>,
  extraRules?: LooseRegisterOptions
): RegisterOptions<T, Path<T>> {
  const rules: LooseRegisterOptions = {
    required: {
      value: !!props.isRequired,
      message: props.requiredErrorMessage || "This field is required"
    },
    minLength: props.minLength
      ? {
          value: props.minLength,
          message: `This field must be at least ${props.minLength} characters long`
        }
      : undefined,
    maxLength: props.maxLength
      ? {
          value: props.maxLength,
          message: `This field must be at most ${props.maxLength} characters long`
        }
      : undefined,
    ...extraRules,
    ...props.rules
  };
  return rules as RegisterOptions<T, Path<T>>;
}
